import React from 'react';
import './_collapse-main-element.scss';
import PropTypes from 'prop-types';

const Translations = ({ children, onOpen, open, items }) => (
  <div className="collapse-container">
    {items.length && items.length > 1 ? (
      <div className="collapse-container__button">
        <span className="collapse-link" onClick={onOpen}>
          {open ? 'Hide' : 'Show'}
          {' '}
          translations (
          {items.length - 1}
          )
        </span>
      </div>
    ) : null}
    {children}
  </div>
);

Translations.propTypes = {
  children: PropTypes.any,
  onOpen: PropTypes.func,
  open: PropTypes.bool,
  items: PropTypes.array,
};
export default Translations;
